export const menuItems = [
    {
        id: 6,
        label: 'menuitems.uielements.text',
        icon: 'bx-tone',
        isUiElement: true,
        subItems: [
            {
                id: 7,
                label: 'menuitems.uielements.list.alerts',
                link: '/',
                parentId: 6
            },
            {
                id: 8,
                label: 'menuitems.uielements.list.buttons',
                link: '/',
                parentId: 6
            },
            {
                id: 9,
                label: 'menuitems.uielements.list.cards',
                link: '/',
                parentId: 6
            },
            {
                id: 10,
                label: 'menuitems.uielements.list.carousel',
                link: '/',
                parentId: 6
            },
            {
                id: 11,
                label: 'menuitems.uielements.list.dropdowns',
                link: '/',
                parentId: 6
            },
            {
                id: 12,
                label: 'menuitems.uielements.list.grid',
                link: '/',
                parentId: 6
            },
            {
                id: 13,
                label: 'menuitems.uielements.list.images',
                link: '/',
                parentId: 6
            },
            {
                id: 14,
                label: 'menuitems.uielements.list.modals',
                link: '/',
                parentId: 6
            },
            {
                id: 14,
                label: 'menuitems.uielements.list.drawer',
                link: '/',
                parentId: 6
            },
            {
                id: 15,
                label: 'menuitems.uielements.list.rangeslider',
                link: '/',
                parentId: 6
            },
            {
                id: 16,
                label: 'menuitems.uielements.list.progressbar',
                link: '/',
                parentId: 6
            },
            {
                id: 17,
                label: 'menuitems.uielements.list.sweetalert',
                link: '/',
                parentId: 6
            },
            {
                id: 18,
                label: 'menuitems.uielements.list.tabs',
                link: '/',
                parentId: 6
            },
            {
                id: 19,
                label: 'menuitems.uielements.list.typography',
                link: '/',
                parentId: 6
            },
            {
                id: 20,
                label: 'menuitems.uielements.list.video',
                link: '/',
                parentId: 6
            },
            {
                id: 21,
                label: 'menuitems.uielements.list.general',
                link: '/',
                parentId: 6
            },
            {
                id: 22,
                label: 'menuitems.uielements.list.colors',
                link: '/',
                parentId: 6
            },
            {
                id: 23,
                label: "menuitems.uielements.list.lightbox",
                link: "/",
                parentId: 6
            },
            {
                id: 24,
                label: "menuitems.uielements.list.cropper",
                link: "/",
                parentId: 6
            },
        ]
    },
    {
        id: 25,
        label: 'menuitems.apps.text',
        icon: 'bx-customize',
        subItems: [
            {
                id: 26,
                label: 'menuitems.calendar.text',
                link: '/',
                parentId: 25
            },
            {
                id: 27,
                label: 'menuitems.chat.text',
                link: '/',
                parentId: 25
            },
            {
                id: 28,
                label: "menuitems.filemanager.text",
                link: "/",
                parentId: 25
            },
            {
                id: 29,
                label: 'menuitems.email.text',
                subItems: [
                    {
                        id: 30,
                        label: 'menuitems.email.list.inbox',
                        link: '/',
                        parentId: 29
                    },
                    {
                        id: 31,
                        label: 'menuitems.email.list.reademail',
                        link: '/',
                        parentId: 29
                    },
                    {
                        id: 32,
                        label: "menuitems.email.list.template.text",
                        parentId: 29,
                        subItems: [
                            {
                                id: 33,
                                label: 'menuitems.email.list.template.list.basic',
                                link: '/',
                                parentId: 32
                            },
                            {
                                id: 34,
                                label: 'menuitems.email.list.template.list.alert',
                                link: '/',
                                parentId: 32
                            },
                            {
                                id: 35,
                                label: 'menuitems.email.list.template.list.billing',
                                link: '/',
                                parentId: 32
                            }
                        ]
                    }
                ]
            },
            {
                id: 36,
                label: 'menuitems.ecommerce.text',
                subItems: [
                    {
                        id: 37,
                        label: 'menuitems.ecommerce.list.products',
                        link: '/',
                        parentId: 36
                    },
                    {
                        id: 38,
                        label: 'menuitems.ecommerce.list.productdetail',
                        link: '/',
                        parentId: 36
                    },
                    {
                        id: 39,
                        label: 'menuitems.ecommerce.list.orders',
                        link: '/',
                        parentId: 36
                    },
                    {
                        id: 40,
                        label: 'menuitems.ecommerce.list.customers',
                        link: '/',
                        parentId: 36
                    },
                    {
                        id: 41,
                        label: 'menuitems.ecommerce.list.cart',
                        link: '/',
                        parentId:36
                    },
                    {
                        id: 42,
                        label: 'menuitems.ecommerce.list.checkout',
                        link: '/',
                        parentId: 36
                    },
                    {
                        id: 43,
                        label: 'menuitems.ecommerce.list.shops',
                        link: '/',
                        parentId: 36
                    },
                    {
                        id: 44,
                        label: 'menuitems.ecommerce.list.addproduct',
                        link: '/',
                        parentId: 36
                    },
                ]
            },
            {
                id: 45,
                label: 'menuitems.crypto.text',
                icon: 'bx-bitcoin',
                link: '/',
            },
            {
                id: 53,
                label: 'menuitems.projects.text',
                subItems: [
                    {
                        id: 54,
                        label: 'menuitems.projects.list.grid',
                        link: '/',
                        parentId: 53
                    },
                    {
                        id: 55,
                        label: 'menuitems.projects.list.projectlist',
                        link: '/',
                        parentId: 53
                    },
                    {
                        id: 56,
                        label: 'menuitems.projects.list.overview',
                        link: '/',
                        parentId: 53
                    },
                    {
                        id: 57,
                        label: 'menuitems.projects.list.create',
                        link: '/',
                        parentId: 53
                    }
                ]
            },
            {
                id: 58,
                label: 'menuitems.tasks.text',
                subItems: [
                    {
                        id: 59,
                        label: 'menuitems.tasks.list.tasklist',
                        link: '/',
                        parentId: 58
                    },
                    {
                        id: 60,
                        label: 'menuitems.tasks.list.kanban',
                        link: '/',
                        parentId: 58
                    },
                    {
                        id: 61,
                        label: 'menuitems.tasks.list.createtask',
                        link: '/',
                        parentId: 58
                    }
                ]
            },
            {
                id: 62,
                label: 'menuitems.contacts.text',
                icon: 'bxs-user-detail',
                subItems: [
                    {
                        id: 63,
                        label: 'menuitems.contacts.list.usergrid',
                        link: '/',
                        parentId: 62
                    },
                    {
                        id: 64,
                        label: 'menuitems.contacts.list.userlist',
                        link: '/',
                        parentId: 61
                    },
                    {
                        id: 65,
                        label: 'menuitems.contacts.list.profile',
                        link: '/',
                        parentId: 61
                    }
                ]
            },
            {
                id: 66, 
                label: "menuitems.blog.text",
                icon: "bx-detail",
                subItems: [
                    {
                        id: 67,
                        label: 'menuitems.blog.list.bloglist',
                        link: '/',
                        parentId: 66
                    },
                    {
                        id: 68,
                        label: 'menuitems.blog.list.grid',
                        link: '/',
                        parentId: 66
                    },
                    {
                        id: 69,
                        label: 'menuitems.blog.list.detail',
                        link: '/',
                        parentId: 66
                    }
                ]
            },
        ]
    },
    {
        id: 70,
        icon: 'bx-collection',
        label: 'menuitems.components.text',
        subItems: [
            {
                id: 71,
                label: 'menuitems.forms.text',
                subItems: [
                    {
                        id: 72,
                        label: 'menuitems.forms.list.elements',
                        link: '/',
                        parentId: 71
                    },
                    {
                        id: 73,
                        label: 'menuitems.forms.list.layouts',
                        link: '/',
                        parentId: 71
                    },
                    {
                        id: 74,
                        label: 'menuitems.forms.list.validation',
                        link: '/',
                        parentId: 71
                    },
                    {
                        id: 75,
                        label: 'menuitems.forms.list.advanced',
                        link: '/',
                        parentId: 71
                    },
                    {
                        id: 76,
                        label: 'menuitems.forms.list.editor',
                        link: '/',
                        parentId: 71
                    },
                    {
                        id: 77,
                        label: 'menuitems.forms.list.fileupload',
                        link: '/',
                        parentId: 71
                    },
                    {
                        id: 78,
                        label: 'menuitems.forms.list.repeater',
                        link: '/',
                        parentId: 71
                    },
                    {
                        id: 79,
                        label: 'menuitems.forms.list.wizard',
                        link: '/',
                        parentId: 71
                    },
                    {
                        id: 80,
                        label: 'menuitems.forms.list.mask',
                        link: '/',
                        parentId: 71
                    }
                ]
            },
            {
                id: 81,
                label: 'menuitems.tables.text',
                subItems: [
                    {
                        id: 82,
                        label: 'menuitems.tables.list.basic',
                        link: '/',
                        parentId: 81
                    },
                    {
                        id: 83,
                        label: 'menuitems.tables.list.advanced',
                        link: '/',
                        parentId: 81
                    }
                ]
            },
            {
                id: 84,
                label: 'menuitems.charts.text',
                subItems: [
                    {
                        id: 85,
                        label: 'menuitems.charts.list.apex',
                        link: '/',
                        parentId: 84
                    },
                    {
                        id: 86,
                        label: 'menuitems.charts.list.chartjs',
                        link: '/',
                        parentId: 84
                    },
                    {
                        id: 87,
                        label: 'menuitems.charts.list.chartist',
                        link: '/',
                        parentId: 84
                    },
                    {
                        id: 88,
                        label: 'menuitems.charts.list.echart',
                        link: '/',
                        parentId: 84
                    }
                ]
            },
            {
                id: 89,
                label: 'menuitems.icons.text',
                subItems: [
                    {
                        id: 90,
                        label: 'menuitems.icons.list.boxicons',
                        link: '/',
                        parentId: 89
                    },
                    {
                        id: 91,
                        label: 'menuitems.icons.list.materialdesign',
                        link: '/',
                        parentId: 89
                    },
                    {
                        id: 92,
                        label: 'menuitems.icons.list.dripicons',
                        link: '/',
                        parentId: 89
                    },
                    {
                        id: 93,
                        label: 'menuitems.icons.list.fontawesome',
                        link: '/',
                        parentId: 89
                    },
                ]
            },
            {
                id: 94,
                label: 'menuitems.maps.text',
                subItems: [
                    {
                        id: 95,
                        label: 'menuitems.maps.list.googlemap',
                        link: '/',
                        parentId: 94
                    },
                    {
                        id: 96,
                        label: "menuitems.maps.list.leafletmap",
                        link: "/",
                        parentId: 94
                    },
                ]
            }
        ]
    },
    {
        id: 97,
        label: 'navbar.dropdown.megamenu.extrapages.title',
        icon: 'bx-file',
        subItems: [
            {
                id: 98,
                label: 'menuitems.invoices.text',
                subItems: [
                    {
                        id: 99,
                        label: 'menuitems.invoices.list.invoicelist',
                        link: '/',
                        parentId: 98
                    },
                    {
                        id: 100,
                        label: 'menuitems.invoices.list.invoicedetail',
                        link: '/',
                        parentId: 98
                    },
                ]
            },
            {
                id: 101,
                label: 'menuitems.authentication.text',
                subItems: [
                    {
                        id: 102,
                        label: "menuitems.authentication.list.login",
                        link: "/",
                        parentId: 101
                    },
                    {
                        id: 103,
                        label: "menuitems.authentication.list.login-2",
                        link: "/",
                        parentId: 101
                    },
                    {
                        id: 104,
                        label: "menuitems.authentication.list.register",
                        link: "/",
                        parentId: 101
                    },
                    {
                        id: 105,
                        label: "menuitems.authentication.list.register-2",
                        link: "/",
                        parentId: 101
                    },
                    {
                        id: 106,
                        label: "menuitems.authentication.list.recoverpwd",
                        link: "/",
                        parentId: 101
                    },
                    {
                        id: 107,
                        label: "menuitems.authentication.list.recoverpwd-2",
                        link: "/",
                        parentId: 101
                    },
                    {
                        id: 108,
                        label: "menuitems.authentication.list.lockscreen",
                        link: "/",
                        parentId: 101
                    },
                    {
                        id:109,
                        label: "menuitems.authentication.list.lockscreen-2",
                        link: "/",
                        parentId: 101
                    },
                    {
                        id: 110,
                        label: "menuitems.authentication.list.confirm-mail",
                        link: "/",
                        parentId: 101
                    },
                    {
                        id: 111,
                        label: "menuitems.authentication.list.confirm-mail-2",
                        link: "/",
                        parentId: 101
                    },
                    {
                        id: 112,
                        label: "menuitems.authentication.list.verification",
                        link: "/",
                        parentId: 101
                    },
                    {
                        id: 113,
                        label: "menuitems.authentication.list.verification-2",
                        link: "/",
                        parentId: 101
                    },
                    {
                        id: 114,
                        label: "menuitems.authentication.list.verification-step",
                        link: "/",
                        parentId: 101
                    },
                    {
                        id: 115,
                        label: "menuitems.authentication.list.verification-step-2",
                        link: "/",
                        parentId: 101
                    }
                ]
            },
            {
                id: 116,
                label: 'menuitems.utility.text',
                icon: 'bx-file',
                subItems: [
                    {
                        id: 117,
                        label: 'menuitems.utility.list.starter',
                        link: '/',
                        parentId: 116
                    },
                    {
                        id: 118,
                        label: 'menuitems.utility.list.maintenance',
                        link: '/',
                        parentId: 116
                    },
                    {
                        id: 118,
                        label: "menuitems.utility.list.comingsoon",
                        link: "/pages/coming-soon",
                        parentId: 116
                    },
                    {
                        id: 119,
                        label: 'menuitems.utility.list.timeline',
                        link: '/',
                        parentId: 116
                    },
                    {
                        id: 120,
                        label: 'menuitems.utility.list.faqs',
                        link: '/',
                        parentId: 116
                    },
                    {
                        id: 121,
                        label: 'menuitems.utility.list.pricing',
                        link: '/',
                        parentId: 116
                    },
                    {
                        id: 122,
                        label: 'menuitems.utility.list.error404',
                        link: '/',
                        parentId: 116
                    },
                    {
                        id: 123,
                        label: 'menuitems.utility.list.error500',
                        link: '/',
                        parentId: 116
                    },
                ]
            },
        ]
    }
];

